var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    d: "M3.25 1h13.5C17.993 1 19 2.007 19 3.25v13.5c0 1.243-1.007 2.25-2.25 2.25H3.25C2.007 19 1 17.993 1 16.75V3.25C1 2.007 2.007 1 3.25 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 15.4L3 10.4 4.4 9 8 12.6 15.6 5 17 6.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.2e0d80c2caafc2ec2d82d04f58e2fab1.svg";
export { ForwardRef as ReactComponent };